<section class="lg:flex md:sm:grid md:sm:grid-cols-1 items-center gap-4">
    @if (!embedded) {
    <a [href]="setupUrl">
      <img [src]="images.arrowLeft" class="h-6 w-6 mr-2.5 cursor-pointer" />
    </a>
    }
    <article class="lg:flex rounded h-10">
      <app-input-search [placeholder]="placeholder" [searchValue]="searchValue" [width]="'60'" (submitEventEmitter)="search($event)"></app-input-search>
    </article>
    <article class="relative lg:flex rounded h-10" (click)="filterOpened = !filterOpened">
      <button id="buttonOpenFilter" 
        class="text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center"
        [ngClass]="{ 'opened' : filterOpened, 'filtersApplied': filtersApplied > 0 }">
        <img [src]="images.filter" alt="filter" class="w-6 h-6 mr-2" [ngClass]="{ 'filterOpened': filterOpened || filtersApplied > 0 }" />
        <span class="font-semibold text-base">{{ literalService.get("bookings.filter", true) }}</span>
      </button>
      @if (filtersApplied > 0) {
        <div class="w-4 h-4 absolute -top-2 -right-2 flex justify-center items-center p-2.5 text-xs font-bold text-white rounded-full filterBubble">
          {{ filtersApplied }}
        </div>
      }
    </article>
    <article class="flex absolute self-start mt-15 w-auto z-10 bg-white" [ngClass]="{ 'hidden': !filterOpened }">
      <app-availability-filter (filter)="applyFilter($event)" (closeFilter)="filterOpened = false" [componentOpen]="'buttonOpenFilter'"></app-availability-filter>
    </article>
    <article class="relative lg:flex rounded h-10">
      <button id="buttonRowsDisplayOpen" 
        class="text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center"
        [ngClass]="{ 'opened' : rowsDisplayOpened, 'filtersApplied': rowsDisplayValue !== defaultRowsDisplay }" (click)="rowsDisplayOpened = !rowsDisplayOpened">
        <img [src]="images.visibility" alt="filter" class="w-6 h-6 mr-2" [ngClass]="{ 'filterOpened': rowsDisplayOpened || rowsDisplayValue !== defaultRowsDisplay }" />
        <span class="font-semibold text-base">{{ `${literalService.get("bookings.show", true)}: ${rowsDisplayValue}` }}</span>
      </button>
      <article class="flex absolute mt-15 w-auto z-10 bg-white" [ngClass]="{ 'hidden': !rowsDisplayOpened }">
        <app-rows-display [componentOpen]="'buttonRowsDisplayOpen'" [value]="rowsDisplayValue" (close)="rowsDisplayOpened = false" (onChange)="updateNumberOfElements($event)"></app-rows-display>
      </article>
    </article>
    @if (searching) {
      <article class="flex items-center pb-2">
        <img [src]="images.loading" alt="loading" class="h-10 w-10 ml-4" />
        <label class="font-semibold text-base ml-4">{{ literalService.get('availabilities.searchingAvailabilities', true) }}...</label>
      </article>
    }
    <section class="flex ml-auto gap-4 items-center">
      @if (allowBulkEditing) {
        <article class="flex flex-row gap-4 items-center">
          @if (bulkSelectedAction === '') {
            <article class="w-10 h-10 flex justify-center items-center rounded-full cursor-pointer outlinedButton" (click)="onCreateDepartures.emit()" [tooltip]="literalService.get('availabilities.actions.createDepartures.title', true)">
              <img [src]="images.setup.addAvailabilities" alt="createDepartures" class="w-6 h-6" />
            </article>
          }
          @for (action of bulkActions; track $index) {
            @if ((bulkSelectedAction !== '' && bulkSelectedAction === action.action) || (bulkSelectedAction === '') ) {
              @if (showActionButton(action.action)) {
                <article class="px-4 py-1 rounded-[44px] cursor-pointer filledButton" (click)="onBulkAction.emit()">
                  {{ literalService.get(action.label, true) }}
                </article>
              }
              <article class="w-10 h-10 flex justify-center items-center rounded-full outlinedButton" [ngClass]="{ 'primary-purple-light-2-background selected': bulkSelectedAction === action.action, 'cursor-pointer': bulkSelectedAction === '' }" (click)="onActionChange(action.action)" [tooltip]="literalService.get(action.label, true)" [visibleTooltip]="bulkSelectedAction === ''">
                <img [src]="action.image" [alt]="action.action" class="w-6 h-6" [ngClass]="{ 'selected': bulkSelectedAction === action.action }" />
              </article>
            }
          }
        </article>
      }
      @if (bulkSelectedAction !== '') {
        <article class="w-10 h-10 flex justify-center items-center rounded-full cursor-pointer outlinedButton" (click)="onActionChange('')">
          <img [src]="images.close" alt="cancelBulk" class="w-6 h-6" />
        </article>
      }
    </section>
  </section>
  